"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IRenderComponent.js.map